let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lUmpc")).then(() => parcelRequire('bPPZx'));